<template>
  <svg :width="size ? size.width : 50" :height="size ? size.height : 50" viewBox="0 0 50 50" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M49.4281 0.354166C49.7901 0.650946 50 1.0944 50 1.56251V45.3125C50 46.0573 49.4743 46.6986 48.7439 46.8447L33.1189 49.9697C32.9166 50.0101 32.7084 50.0101 32.5061 49.9697L17.1875 46.906L1.86893 49.9697C1.40991 50.0615 0.933905 49.9426 0.571892 49.6459C0.20988 49.3491 0 48.9056 0 48.4375V4.68751C0 3.9427 0.525718 3.30143 1.25607 3.15536L16.8811 0.0303561C17.0834 -0.0101007 17.2916 -0.0101007 17.4939 0.0303561L32.8125 3.09407L48.1311 0.0303561C48.5901 -0.0614486 49.0661 0.0573871 49.4281 0.354166ZM31.25 5.96846L18.75 3.46846V44.0316L31.25 46.5316V5.96846ZM34.375 46.5316L46.875 44.0316V3.46846L34.375 5.96846V46.5316ZM15.625 44.0316V3.46846L3.125 5.96846V46.5316L15.625 44.0316Z"
      fill="#121212" />
  </svg>
</template>
<script>
export default {
  props: ['size']
}
</script>